export default __webpack_public_path__ + "static/media/service-road-straight.ccee4526.svg";